module.exports = __webpack_public_path__ + "static/media/FirstResponse.df65327c.svg";